module.exports = __webpack_public_path__ + "img/Group521@2x.0b7fa6a9.png";